export const NATURAL = [
  {
    "id": "n1",
    "name": "Ajwain",
    "description": "Spicy and pungent oil used for digestive issues, respiratory relief, and antimicrobial support."
  },
  {
    "id": "n2",
    "name": "Bay Leaf",
    "description": "Warm, camphoraceous oil known for pain relief, respiratory support, and immune boosting."
  },
  {
    "id": "n3",
    "name": "Basil",
    "description": "Energizing oil that aids focus, relieves stress, and supports respiratory health."
  },
  {
    "id": "n4",
    "name": "Black Pepper",
    "description": "Stimulating and warming oil used for circulation, muscle pain, and detoxification."
  },
  {
    "id": "n5",
    "name": "Cardamom",
    "description": "Sweet and spicy oil that supports digestion, respiratory health, and emotional balance."
  },
  {
    "id": "n6",
    "name": "Carrot Seed",
    "description": "Earthy oil prized for skin rejuvenation, detoxification, and liver support."
  },
  {
    "id": "n7",
    "name": "Cassia",
    "description": "Intensely spicy oil similar to cinnamon, used for immune support and emotional warmth."
  },
  {
    "id": "n8",
    "name": "Cedarwood",
    "description": "Woody and grounding oil that promotes relaxation, sleep, and skin health."
  },
  {
    "id": "n9",
    "name": "Celery",
    "description": "Herbaceous oil known for detoxifying, calming, and digestive benefits."
  },
  {
    "id": "n10",
    "name": "Cinnamon Leaf",
    "description": "Warm and spicy oil with antimicrobial and circulation-boosting properties."
  },
  {
    "id": "n11",
    "name": "Citronella",
    "description": "Bright, lemony oil famous for repelling insects and uplifting mood."
  },
  {
    "id": "n12",
    "name": "Clove Bud / Leaf",
    "description": "Strong antiseptic oil used for dental care, pain relief, and immune support."
  },
  {
    "id": "n13",
    "name": "Coriander",
    "description": "Sweet and woody oil that aids digestion, soothes joints, and calms the mind."
  },
  {
    "id": "n14",
    "name": "Cumin",
    "description": "Earthy and spicy oil used for digestive health and immune support."
  },
  {
    "id": "n15",
    "name": "Curry Leaf",
    "description": "Aromatic oil known for promoting hair growth, skin health, and digestion."
  },
  {
    "id": "n16",
    "name": "Cypriol (Nagarmotha)",
    "description": "Woody and earthy oil used in perfumery and for detoxifying and calming effects."
  },
  {
    "id": "n17",
    "name": "Davana",
    "description": "Fruity and herbaceous oil used in perfumery and emotional balancing."
  },
  {
    "id": "n18",
    "name": "Dill Seed",
    "description": "Sweet and herbaceous oil that supports digestion and calms the nervous system."
  },
  {
    "id": "n19",
    "name": "Fennel",
    "description": "Sweet, licorice-like oil used for hormonal balance, digestion, and mental clarity."
  },
  {
    "id": "n20",
    "name": "Frankincense",
    "description": "Resinous and grounding oil revered for meditation, skin healing, and immune support."
  },
  {
    "id": "n21",
    "name": "Garlic",
    "description": "Pungent oil with strong antimicrobial and immune-boosting properties."
  },
  {
    "id": "n22",
    "name": "Ginger",
    "description": "Warm and spicy oil that aids digestion, reduces inflammation, and boosts circulation."
  },
  {
    "id": "n23",
    "name": "Gingergrass",
    "description": "Fresh and lemony oil used for stress relief, skin care, and respiratory support."
  },
  {
    "id": "n24",
    "name": "Holy Basil (Tulsi)",
    "description": "Spicy and sweet oil used in Ayurveda for stress relief, immunity, and spiritual clarity."
  },
  {
    "id": "n25",
    "name": "Juniper Berry",
    "description": "Crisp and woody oil that detoxifies, supports urinary health, and purifies the air."
  },
  {
    "id": "n26",
    "name": "Lemongrass",
    "description": "Citrusy and fresh oil known for pain relief, antibacterial action, and mood lifting."
  },
  {
    "id": "n27",
    "name": "Mace",
    "description": "Warm and spicy oil used for digestion, circulation, and emotional grounding."
  },
  {
    "id": "n28",
    "name": "Marjoram",
    "description": "Herbal oil that soothes muscles, calms nerves, and supports respiratory health."
  },
  {
    "id": "n29",
    "name": "Mustard",
    "description": "Pungent oil used traditionally for circulation, joint pain, and skin stimulation."
  },
  {
    "id": "n30",
    "name": "Neem",
    "description": "Bitter and earthy oil with powerful antifungal, antibacterial, and skin-healing properties."
  },
  {
    "id": "n31",
    "name": "Nutmeg",
    "description": "Sweet and spicy oil that supports digestion, relieves pain, and enhances mood."
  },
  {
    "id": "n32",
    "name": "Oregano",
    "description": "Potent antimicrobial oil used for immune support and respiratory health."
  },
  {
    "id": "n33",
    "name": "Palmarosa",
    "description": "Floral and grassy oil that hydrates skin, balances emotions, and fights bacteria."
  },
  {
    "id": "n34",
    "name": "Rosemary",
    "description": "Herbal and invigorating oil that boosts memory, relieves pain, and supports hair growth."
  },
  {
    "id": "n35",
    "name": "Star Anise",
    "description": "Sweet licorice-scented oil used for respiratory relief, digestion, and calming effects."
  },
  {
    "id": "n36",
    "name": "Turmeric",
    "description": "Earthy and spicy oil with strong anti-inflammatory, antioxidant, and skin-healing benefits."
  },
  {
  "id": "n37",
  "name": "Rose",
  "description": "Soft, floral fragrance known for uplifting emotions, calming the mind, and evoking romance."
},
{
  "id": "n38",
  "name": "Ruh Gulab (Rose Attar)",
  "description": "Traditional rose attar with a rich, natural floral aroma valued for cooling and emotional balance."
},
{
  "id": "n39",
  "name": "Ruh Khus (Vetiver Attar)",
  "description": "Earthy and cooling attar with deep woody notes that ground the senses and calm the mind."
},
{
  "id": "n40",
  "name": "Jasmine",
  "description": "Intensely floral and sweet perfume that uplifts mood and enhances confidence and warmth."
},
{
  "id": "n41",
  "name": "Mehandi",
  "description": "Green and herbaceous fragrance with earthy tones offering a traditional and calming aroma."
},
{
  "id": "n42",
  "name": "Mitty",
  "description": "Distinct earthy fragrance reminiscent of first rain on dry soil, grounding and comforting."
},
{
  "id": "n43",
  "name": "Kewra",
  "description": "Fresh and sweet floral attar with a light, cooling aroma that refreshes the senses."
},
{
  "id": "n44",
  "name": "Shamama",
  "description": "Rich and complex traditional attar with spicy, floral, and woody notes for deep warmth."
},
{
  "id": "n45",
  "name": "Oudh",
  "description": "Deep, woody, and resinous fragrance prized for its richness, depth, and long-lasting character."
},
{
  "id": "n46",
  "name": "Saffron Attar (Kesar / Zaffran Attar)",
  "description": "Warm and exotic attar with soft leathery notes, known for elegance and emotional warmth."
}

];